import styled from 'styled-components'

export const InnerContainer = styled.div<{ isNarrow?: boolean }>`
  max-width: ${(p) => (p.isNarrow ? `460px` : `600px`)};
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`
